
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Best Graphic Designers in Goa",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Graphic Design Services include Logo Design & Branding, Print Design, Brochures, & more. Check Our Graphic Design Services Packages!'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'goa tourism, goa tourism packages, goa tourism places, goa tourism hotels, nightlife goa tourism, goa tourism hotel booking'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Best Graphic Designers in Goa'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Graphic Design Services include Logo Design & Branding, Print Design, Brochures, & more. Check Our Graphic Design Services Packages!'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Best Graphic Designers in Goa'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Graphic Design Services include Logo Design & Branding, Print Design, Brochures, & more. Check Our Graphic Design Services Packages!'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Best Graphic Designers in Goa'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/graphic-design.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/graphic-design.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/graphic-design.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Best Graphic Designers in Goa',
      description: 'Graphic Design Services include Logo Design & Branding, Print Design, Brochures, & more. Check Our Graphic Design Services Packages!',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
		},
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },

 jsonld() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://goa.app/graphic-design/#Service",
        "url": "https://goa.app/graphic-design",
        "name": "Graphic Design",
        "description": "We're passionate about all things design - logos, websites, apps, social media, offline collaterals like menus, flyers, visiting cards, banner and hoarding graphic designs in Goa.",
       "datePublished": "2024-06-14T00:00:00",
       "dateModified":  "2024-06-14T00:00:00",	
        "image": "https://goa.app/img/service-imgs/graphic-design.webp",
        "serviceType": "Digital Marketing",
        "additionalType": "serviceOutput",
        "providerMobility": "provider",
        "provider": {
          "@type": "Corporation",
          "name": "Goa App",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Goa",
            "postalCode": "403505"
          },
          "telephone": "+91 9049248689"
        },
        "priceRange": "",
        "areaServed": {
          "@type": "City",
          "name": "Goa"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Graphic Design",
          "itemListElement": [
            {
              "@type": "Offer",
              "name": "Logo Design & Branding"
            },
            {
              "@type": "Offer",
              "name": "Brochures and Menus"
            },
            {
              "@type": "Offer",
              "name": "Newsletters"
            },
            {
              "@type": "Offer",
              "name": "Print Design"
            },
            {
              "@type": "Offer",
              "name": "Advertising"
            },
            {
              "@type": "Offer",
              "name": "Package Design"
            },
            {
              "@type": "Offer",
              "name": "Infographics"
            },
            {
              "@type": "Offer",
              "name": "Web Design"
            },
            {
              "@type": "Offer",
              "name": "App Design"
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What Type of Graphic Design Services Do You Offer?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You name it, we create it. Your marketing materials need to be cohesive and consistent, so our graphic design services span logos, websites, business cards, stationery, print materials, signs, animated videos, brochures, food menus, emailer designs, PowerPoint templates, packaging and labels, flyers, and much more."
            }
          },
          {
            "@type": "Question",
            "name": "What Do You Need from Me to Get Started?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We have a list of things you can help us with to make the design process more seamless and speedy. The more you help us with from that list, the easier it is for us to design something that meets or exceeds your expectations."
            }
          },
          {
            "@type": "Question",
            "name": "How Do Payments Work?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "For all our design services, we require a 50% advance before we begin the project. Depending on the size of the project, we either set up a payment schedule to match the progress in design or, in the case of a smaller project, we ask for the balance at the end of the project after you approve the final design, but before we hand over the open/source files to you."
            }
          },
          {
            "@type": "Question",
            "name": "How Much Do Your Graphic Design Services Cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Great design is an investment and takes dedication and time. Since every project is unique, there are no set prices for our work. We create custom, value-based proposals for all projects because every client has different needs. Our work starts with research and strategy, creation of mood boards to set the tone, actual design work which can take anywhere between a couple of days to a few weeks, and then incorporation of feedback. We often ask clients what their budgets are to determine what we can offer that fits within this budget. However, you can get in touch with us to understand our ballpark figures."
            }
          },
          {
            "@type": "Question",
            "name": "How Long Will This Take? I Need Designs ASAP!",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We can tell you one thing – you won’t get your logo next week – that’s not how we operate. While we have quick turnaround times for things like social media ads and social media posts, things like logos, menus, websites, packaging, etc., take a significant amount of research and strategy, involving rounds of design, feedback, and edits. Depending on the complexity and the brief you give us, this can take anywhere between 2 weeks and 2 months."
            }
          }
        ]
      }
    ]
  };
},

  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
